<template>
  <div class="opc-users-change-container" v-show="show">
    {{ text }}
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import { plansof } from '@/utils/chain';

export default {
  name: 'UsersChange',
  props: {
    type: String,
    value: Number,
  },
  computed: {
    ...mapGetters(['getSelectedPlans', 'boughtPlans']),
    show() {
      return this.cartPlan?.cartInfo?.selected_number &&
        this.boughtPlan?.cartInfo?.selected_number &&
        this.cartPlan?.cartInfo?.selected_number !== this.boughtPlan?.cartInfo?.selected_number;
    },
    changes() {
      return `${this.changesNumber > 0 ? '+' : ''}${this.changesNumber}`;
    },
    text() {
      return this.changesNumber > 0 ?
        this.$t('billing.simplify.change_increase_users', [this.changes]) :
        this.$t('billing.simplify.change_decrease_users', [this.changes])
    },
    changesNumber() {
      return this.show ?
        this.cartPlan?.cartInfo?.selected_number - this.boughtPlan?.cartInfo?.selected_number :
        0;
    },
    cartPlan() {
      if(this.code) return plansof(this.getSelectedPlans).code(this.code).get(0);
      return plansof(this.getSelectedPlans).type(this.type).get(0);
    },
    boughtPlan() {
      const category = this.cartPlan.category;
      return plansof(this.boughtPlans).type(this.type).category(category).get(0);
    },
  }
}
</script>

<style lang="scss" scoped>
.opc-users-change-container {
  color: #686F79;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  margin-top: 4px;
}
</style>
